import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom';
import { RenderLearningMethod } from '../../../utils/CommonGroupingItem';
import DataTableComponentFrontPagination from '../../common/DataTableComponentFrontPagination';
import { RenderCourseAssignedlistStatus, RenderWebsitelistStatus } from '../../../utils/CommonStatusItems';
import SkeletonTicketList from '../../../loaders/SkeletonTicketList';
import $ from "jquery"

function EmailAvailableShortCourse({AvailablefilterData , availableRec , availableLoading , handleAdd,assignedRec,setAssignedRec }) {
    const [searchAssigned, setSearchAssigned] = useState("");
    const [courseStudyType, setCourseStudyType] = useState({ arr: [], checkObj: {} })
    const [courseIntake, setCourseIntake] = useState({ arr: [], checkObj: {} })


    const availableColumns = useMemo(() => [
        {
            name: "Name",
            selector: "name",
            sortField: "name",
            sortable: true,
            cell: (row) => (
                <Link
                    className="as-text-blue curser feature-name"
                    to={`/websiteManagement/pages/programmes_and_short_courses/short_course_page/details/open/${row.id}`}
                    onClick={() => $("#availableShortCourse").modal("hide")}
                    title={row.name}
                >
                    <span className="textLimit100">{row.name}</span>
                </Link>
            ),
        },
        {
            name: "Status",
            selector: "status",
            sortField: "status",
            sortable: true,
            cell: (row) => (row.publish_status ? RenderCourseAssignedlistStatus(row.publish_status).html : "-"),
        },
        {
            name: "Code",
            selector: "Code",
            sortField: "Code",
            sortable: true,
            cell: (row) => (row.Code ? row.Code : "-"),
        },
        {
            name: "Linked PMC Short Course",
            selector: "LinkedProgrammeName",
            sortable: true,
            cell: (row) => (
                <Link
                    className="as-text-blue curser feature-name"
                    to={`/program-management-center/programmes/shortCourse/open/${row.pmc_id}`}
                    onClick={() => $("#availableShortCourse").modal("hide")}
                    title={row.LinkedProgrammeName}
                >
                    <span className="textLimit100">{row.LinkedProgrammeName}</span>
                </Link>
                
                // <span className="as-text-blue curser feature-name" title={row.LinkedProgrammeName}>{row.LinkedProgrammeName}</span>
                
            )
        },
        {
            name: "Actions",
            selector: "",
            className: "permission-tabe-last-cell",
            cell: (row) => {
              const isAssigned = assignedRec.some(item => {
               return item.id == row.id
            });
              return (
                <div className="assessment-08">
                  <div className="as-buttons">
                            
                    {isAssigned ? (
                      // Show the "Unassign" button if the item is assigned
                      <button
                        type="button"
                        className="btn btn-danger rounded-circle"
                        onClick={() => {
                            const updateData = assignedRec.filter((elem, ind) => {
                                return elem.id !== row.id
                            });
                            setAssignedRec(updateData)
                        }
                        }
                        title="Unassign Page"
                      >
                        <i className="fal fa-minus"></i>
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary rounded-circle"
                        onClick={() => handleAdd(row, "add", "Course")}
                        title="Assign Page"
                      >
                        <i className="fal fa-plus"></i>
                      </button>
                )} 
                  </div>
                </div>
              );
            },
          }     
    ]);

    const dataToRenderAvailable = () => {
        let updatedData = [];
        let allData = availableRec;

        if (searchAssigned.length) {
            let name = allData?.filter((item) => {
                let includes = item?.name?.toString()
                    .toLowerCase()
                    .includes(searchAssigned.toLowerCase());
                if (includes) {
                    return includes;
                } else return null;
            });

            let data = [...name];
            let unique = [...new Set(data)];

            updatedData = unique;
        } else {
            updatedData = allData;
        }

        if (courseStudyType.arr.length) {
            let tempAssignStudy = updatedData;
            let tempIntakeHash = tempAssignStudy.filter((item) => {
                const startsMarking = courseStudyType.arr.find((it) => it == item.pmc_id)
                if (startsMarking) {
                    return startsMarking;
                } else return null;
            });
            
            updatedData = tempIntakeHash;
        }
        if (courseIntake.arr.length) {
            let tempIntake = updatedData;
            let tempIntakeHash = tempIntake.filter((item) => {
                const startsMarking = courseIntake.arr.find((it) => it == item.publish_status)
                if (startsMarking) {
                    return startsMarking;
                } else return null;
            });

            updatedData = tempIntakeHash;
        }

        if (
            searchAssigned.length ||
            courseIntake.arr.length ||
            courseStudyType.arr.length
        ) {
            return updatedData;
        } else {
            return availableRec;
        }
    };

    const exportAvailableData = () => {
        let data = dataToRenderAvailable();
        const header = [
            "Name",
            "Status",
            "Code",
            "Linked PMC Short Course",
        ];
        data = data.map((row) => ({
            "Name": row.name ? row.name : "-",
            "Status": row?.publish_status ? RenderCourseAssignedlistStatus(row.publish_status).text : "-" ,
            "Code": row.Code ? row.Code : "-",
            "Linked PMC Short Course": row?.LinkedProgrammeName ? row.LinkedProgrammeName : "-",
        }));
        
        const pdfData = data.map((row) => {
            return [
                row["Name"],
                row["Status"],
                row["Code"],
                row["Linked PMC Short Course"]
            ];
        });
        return {
            header,
            data,
            pdfData,
            columnStyles: {}
        }
    };

    return (
        <>
            <div className="modal-content">
                <div className="modal-header modal-header-custom"><h5 className="modal-title"><i className="fal fa-plus"></i> Assign Short Course</h5><button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button></div>
                <div className="modal-body">
                    <DataTableComponentFrontPagination
                        data={dataToRenderAvailable()}
                        columns={availableColumns}
                        loading={availableLoading}
                        exportData={exportAvailableData}
                        exportFileName={"Assigned_shortCourse"}
                        defaultSort={{ defaultSortColumn: "name", defaultSortAsc: false }}
                        custumcss="border-0"
                        search={searchAssigned}
                        progressComponent={<SkeletonTicketList />}
                        setSearch={setSearchAssigned}
                        filters={[
                            {
                                filterName: "Status",
                                optionArr: AvailablefilterData.intake || [],
                                state: courseIntake,
                                setState: setCourseIntake,
                                uniqueId: "courseIntake",
                                isOptionReversed: true,
                                renderLabelFunction: RenderCourseAssignedlistStatus,
                            },
                            {
                                filterName: "Linked PMC Short Course",
                                optionArr: AvailablefilterData.linked || [],
                                state: courseStudyType,
                                setState: setCourseStudyType,
                                uniqueId: "availableStudyType",
                                // renderLabelFunction: RenderLearningMethod,
                            }
                        ]}
                    />
                </div>
            </div>
        </>
    )
}

export default EmailAvailableShortCourse